import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { PricesSliceInitialState } from './pricesTypes';
import { getPrices } from './pricesActions';

const initialState: PricesSliceInitialState = {
  prices: [],
  isLoading: false,
};

export const pricesSlice = createSlice({
  name: '@@prices',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPrices.fulfilled, (state, action) => {
      state.prices = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getPrices.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getPrices.pending, (state) => {
      state.isLoading = true;
    });
  },
});

export const pricesSelector = createSelector(
  [(state: RootState) => state.prices.prices],
  (info) => info
);

export const isLoadingPricesSelector = createSelector(
  [(state: RootState) => state.prices.isLoading],
  (info) => info
);
